import React from 'react';
import './FactoringNotice.css';

const AnnulmentNotice = ({ text, downloadUrl, variant = 'default' }) => {
  // Default (red) variant for reclamado/anulada
  const isDefaultVariant = variant === 'default';
  
  // Styles for default (red) variant
  const defaultStyles = {
    background: 'linear-gradient(135deg, #fef3f3 0%, #fde8e8 100%)',
    border: '1px solid #f5c6cb',
    iconColor: 'var(--salmon)',
    textColor: '#991b1b',
    linkColor: 'var(--salmon)'
  };
  
  // Styles for "No incluir" (black) variant
  const noIncluirStyles = {
    background: 'linear-gradient(135deg, var(--bg) 0%, var(--border) 100%)',
    border: '1px solid var(--border)',
    iconColor: 'var(--marengo)',
    textColor: 'var(--marengo)',
    linkColor: 'var(--marengo)'
  };
  
  const styles = isDefaultVariant ? defaultStyles : noIncluirStyles;
  
  return (
    <div className="factoring-notice" style={{ 
      background: styles.background,
      border: styles.border
    }}>
      <div className="factoring-notice__icon" style={{ color: styles.iconColor }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="factoring-notice__content">
        <div className="factoring-notice__text" style={{ color: styles.textColor }}>
          {text}
        </div>
        {downloadUrl && (
          <div className="factoring-notice__link">
            <a 
              href={downloadUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="factoring-notice__link-text"
              style={{ color: styles.linkColor }}
            >
              Ver respaldo
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default AnnulmentNotice; 